// snackbarStore.js
import { create } from 'zustand';

// Create a store for snackbar state
const useSnackbarStore = create((set) => ({
  open: false,
  message: '',
  severity: 'info',
  autoHideDuration: 6000,
  
  // Show the snackbar
  showSnackbar: (message, severity = 'info', autoHideDuration = 6000) => 
    set({ open: true, message, severity, autoHideDuration }),
  
  // Hide the snackbar
  hideSnackbar: () => set({ open: false }),
}));

export default useSnackbarStore;
